{
  "states": {
    "loading": "Duke ngarkuar...",
    "unavailable": "--"
  },
  "button": {
    "defaultCity": "San Francisco"
  },
  "conditions": {
    "Clear": "I kthjellët",
    "Clouds": "Me re",
    "Rain": "Shi",
    "Drizzle": "Shi i imët",
    "Thunderstorm": "Stuhi me bubullima",
    "Snow": "Borë",
    "Mist": "Mjegullinë",
    "Smoke": "Tym",
    "Haze": "Mjegullnajë",
    "Dust": "Pluhur",
    "Fog": "Mjegull",
    "Sand": "Rërë",
    "Ash": "Hi",
    "Squall": "Furtunë",
    "Tornado": "Tornado"
  },
  "modal": {
    "defaultTitle": "Moti",
    "subtitle": "Kushtet aktuale",
    "showFahrenheit_aria": "Shfaq Fahrenheit",
    "showCelsius_aria": "Shfaq Celsius",
    "switchToCelsius_title": "Kalo në °C",
    "switchToFahrenheit_title": "Kalo në °F",
    "feelsLike": "Ndihet si {{temp}}°{{unit}}",
    "humidityWind": "Lagështia {{humidity}}% · Era {{wind}}",
    "windSpeed": "{{speed}} mph",
    "hourlyNow": "Tani",
    "hourlyOffset": "{{hours}}h",
    "hourlyStrip_aria": "Temperatura orë pas ore",
    "hourlyLocked": "Parashikimi orar është veçori Pro.",
    "statsLocked": "Detajet e motit janë veçori Pro.",
    "stats": {
      "sunrise": "Lindja e diellit",
      "sunset": "Perëndimi i diellit",
      "feels": "Ndihet",
      "humidity": "Lagështia",
      "wind": "Era",
      "rain": "Shi"
    },
    "rainInches": "{{value}} in",
    "forecastTitle": "Parashikimi 5-ditor",
    "forecastLoading": "Duke ngarkuar parashikimin…",
    "forecastUnavailable": "Parashikimi i padisponueshëm",
    "forecastLocked": "Parashikimi 5-ditor është veçori Pro.",
    "forecastRow_aria": "Parashikimi pesë-ditor",
    "proHeadline": "Parashikimi i plotë është pjesë e Pro.",
    "proFeatures": "Çdo orë · Kushte të detajuara · Parashikim 5-ditor."
  }
}
